export default __webpack_public_path__ + "assets/non-animated-tablet.png";